import { render, staticRenderFns } from "./editDepartments.vue?vue&type=template&id=a239f45c&scoped=true"
import script from "./editDepartments.vue?vue&type=script&lang=js"
export * from "./editDepartments.vue?vue&type=script&lang=js"
import style0 from "./editDepartments.vue?vue&type=style&index=0&id=a239f45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a239f45c",
  null
  
)

export default component.exports